import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators'

@Component({
  selector: 'ff-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent implements OnInit {

  @Input() placeholder: string = "Search";
  
  // Event emitter on search
  @Output() search = new EventEmitter<string>();

  //Subject to subscribe
  private subjectKeyUp = new Subject<any>();

  constructor() {}

  ngOnInit(): void {
    this.subjectKeyUp.pipe(debounceTime(1000)).subscribe((searchString) => {
      this.search.emit(searchString);
    });
  }

  onSearch($event) {
    const value = $event.target.value;
    this.subjectKeyUp.next(value);
  }
}
